import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Loader } from 'semantic-ui-react';
import { ReqItemComponent } from '../req-item';
import { ReqStatusActionsComponent } from '../req-status';
import ReqsFilterComponent from '../../../reqs-filter';
import './styles.less';
import TablePagination from '../../../../semantic-ui/components/table-pagination';
import { AuctionComponent } from '../auction';
import { Timer } from '../timer';

export const ReqWrapper = ({
	reqs,
	onActionButtonClick,
	onModalOpen,
	pagination,
	isReqsLoading,
	onAuctionInfoChange,
	onKeyDown,
	isTimerVisible,
	onExport,
	onSelectAll,
	onDeselectAll,
	showExportButton,
	isReqsSending,
	isDownloadLoading,
}) => {
	return (
		<>
			<div className="req-wrapper__header">
				<div className="req-wrapper__header-left">
					<div className="req-wrapper__actions">
						<div className="deselect-all-button" onClick={onDeselectAll} />
						<div className="select-all-button" onClick={onSelectAll} />
					</div>
					{showExportButton && (
						<div className="req-wrapper__actions">
							<Dropdown
								icon={null}
								className="download-dropdown"
								floating
								labeled
								button
								loading={isDownloadLoading}
								disabled={isDownloadLoading}
								trigger={
									<div className={`download-button ${isDownloadLoading ? 'download_loading' : ''}`} />
								}
								direction="right"
							>
								<Dropdown.Menu>
									<Dropdown.Item text="Экспорт заявок" onClick={onExport} />
								</Dropdown.Menu>
							</Dropdown>
						</div>
					)}
					{onModalOpen && (
						<button type="button" className="req-wrapper__button" onClick={onModalOpen}>
							Создать заявку
						</button>
					)}
				</div>
				{isTimerVisible && <Timer />}
			</div>
			<div className="req-wrapper">
				{reqs?.length > 0 ? (
					<div className="req-wrapper__reqs">
						{reqs.map((item, index) => {
							return (
								<div key={item.id} className="req-wrapper__reqs-items">
									<div className={`req-wrapper__reqs-${item.labels ? 'item-with-labels' : 'item'}`}>
										<ReqItemComponent key={`${item.id}${index + 1}`} item={item} />
									</div>
									<div className="req-wrapper__reqs-status">
										{item.auction ? (
											<AuctionComponent
												actions={item.actions}
												auction={item.auction}
												onActionButtonClick={onActionButtonClick}
												offer={item.offer}
												reqId={item.id}
												onAuctionInfoChange={onAuctionInfoChange}
												onKeyDown={onKeyDown}
												isDateFieldDisabled={item.points?.length > 2}
												withLabels={Boolean(item.labels)}
											/>
										) : (
											<ReqStatusActionsComponent
												isReqsSending={isReqsSending}
												status={item.status}
												actions={item.actions}
												badges={item.badges}
												onActionButtonClick={onActionButtonClick}
												reqId={item.id}
												timeline={item.timeline}
												withLabels={Boolean(item.labels)}
											/>
										)}
									</div>
								</div>
							);
						})}
						{pagination && <TablePagination pagination={pagination} isShort />}
					</div>
				) : (
					<div className="req-wrapper__reqs">
						<div className="req-wrapper__empty-list">
							{isReqsLoading ? (
								<div className="req-wrapper__loader">
									<Loader active inline />
								</div>
							) : (
								<div className="req-wrapper__empty-list-text">Заявки не найдены</div>
							)}
						</div>
					</div>
				)}

				<div className="req-wrapper__filter">
					<ReqsFilterComponent />
				</div>
			</div>
		</>
	);
};

ReqWrapper.propTypes = {
	reqs: PropTypes.array.isRequired,
	onActionButtonClick: PropTypes.func.isRequired,
	onModalOpen: PropTypes.func,
	pagination: PropTypes.shape({
		currentPage: PropTypes.number,
		totalPages: PropTypes.number.isRequired,
		total: PropTypes.number,
		from: PropTypes.number,
		to: PropTypes.number,
		isNextItem: PropTypes.bool,
		isPrevItem: PropTypes.bool,
		isFirstItem: PropTypes.bool,
		isLastItem: PropTypes.bool,
	}),
	isReqsLoading: PropTypes.bool.isRequired,
	isReqsSending: PropTypes.array,
	onAuctionInfoChange: PropTypes.func.isRequired,
	onKeyDown: PropTypes.func.isRequired,
	isTimerVisible: PropTypes.bool.isRequired,
	onExport: PropTypes.func,
	onSelectAll: PropTypes.func.isRequired,
	onDeselectAll: PropTypes.func.isRequired,
	showExportButton: PropTypes.bool.isRequired,
	isDownloadLoading: PropTypes.bool.isRequired,
};
